// FRONTEND PAGE ROUTE CONSTANTS

export const PAGE_ROUTES = {
	ROOT: '/',
	DASHBOARD: '/',

	// AUTHENTICATION
	LOGIN: 'auth-pages/login',
	FORGOT_PASSWORD: 'auth-pages/forgot-password',
	RESET_PASSWORD: 'auth-pages/reset-password/:token',
	PAGE_404: 'auth-pages/404',

	// ADMIN & PROFILE
	PROFILE: 'admin/profile',
	GENERAL_SETTING: 'setting/general',
	COMPANY: 'setting/company',
	INVOICE_NUMBERING: 'setting/invoice-numbering',

	// USER MANAGEMENT
	USERS: 'users',
	USERS_ADD: 'users/add',
	USERS_VIEW: 'users/view/:id',
	USERS_EDIT: 'users/edit/:id',
	ROLES: 'roles',
	ROLES_ADD: 'roles/add',
	ROLES_VIEW: 'roles/view/:id',
	ROLES_EDIT: 'roles/edit/:id',

	// LOGIN HISTORY
	LOGIN_HISTORY: 'login-history',
	LOGIN_HISTORY_USER: 'login-history/:id',

	// MASTERS
	ITEMS: 'masters/items',
	ITEM_TYPES: 'masters/item-types',
	SIZES: 'masters/sizes',
	COLOURS: 'masters/colours',
	PROCESSES: 'masters/processes',
	FABRICS: 'masters/fabrics',
	FABRIC_TYPES: 'masters/fabric-types',
	FABRIC_STAGES: 'masters/fabric-stages',
	PARTIES: 'masters/parties',
	CUTTING_COMPONENTS: 'masters/cutting-components',
	LABOURS: 'masters/labours',
	EXPENSE_CATEGORIES: 'masters/expense-categories',
	TAX_RATES: 'masters/tax-rates',

	// PRODUCTION
	FABRIC_INWARDS: 'production/fabric-inwards',
	FABRIC_INWARDS_VIEW: 'production/fabric-inwards/view/:id',
	FABRIC_STOCK: 'production/fabric-stock',
	CUTTING_STOCK: 'production/cutting-stock',
	CUTTING: 'production/cutting',
	CUTTING_VIEW: 'production/cutting/view/:id',
	BUNDLING: 'production/bundling',
	BUNDLING_VIEW: 'production/bundling/view/:id',
	BUNDLE_STOCK: 'production/bundle-stock',
	PROCESS_ISSUE: 'production/process-work/:processId',
	PROCESS_ISSUE_VIEW: 'production/process-issue/view/:id',
	PROCESS_FLOW: 'production/process-flow',
	READY_STOCK: 'production/ready-stock',
	LABOUR_HISAAB: 'production/labour-hisaab',
	LABOUR_HISAAB_MONTHLY_SALARY: 'production/labour-hisaab/monthly-salary',
	LABOUR_HISAAB_VIEW: 'production/labour-hisaab/view/:id',
	DELIVERY_CHALLAN: 'production/delivery-challan',
	// SALES_ORDER: 'sales/sales-order',
	SALES_INVOICE: 'sales/sales-invoice',
	SALES_INVOICE_VIEW: 'sales/sales-invoice/view/:id',
	CUSTOMER_PAYMENT: 'sales/customer-payment',
	CREDIT_NOTE: 'sales/credit-note',
	CREDIT_NOTE_ADD: 'sales/credit-note/add',
	CREDIT_NOTE_EDIT: 'sales/credit-note/edit/:id',
	// PURCHASE_ORDER: 'purchase/purchase-order',
	PURCHASE_INVOICE: 'purchase/purchase-invoice',
	PURCHASE_INVOICE_VIEW: 'purchase/purchase-invoice/view/:id',
	SUPPLIER_PAYMENT: 'purchase/supplier-payment',
	DEBIT_NOTE: 'purchase/debit-note',
	DEBIT_NOTE_ADD: 'purchase/debit-note/add',
	DEBIT_NOTE_EDIT: 'purchase/debit-note/edit/:id',
	EXPENSES: 'finance/expenses',
	EXPENSE_VIEW: 'finance/expenses/view/:id',
	PETTY_CASH: 'finance/petty-cash',
	BANK: 'finance/bank',
	DELIVERY_CHALLAN_VIEW: 'production/delivery-challan/view/:id',

	// REPORTS
	REPORTS: 'reports',
	REPORTS_DASHBOARD: 'reports/dashboard',
	REPORT_DETAIL: 'reports/:reportKey',
	REPORT_LABOUR_PAYMENT_MONTHLY_SALARY: 'reports/:reportKey/monthly-salary',
} as const;

export type TPageRoutes = (typeof PAGE_ROUTES)[keyof typeof PAGE_ROUTES];

export default PAGE_ROUTES;
